__turbopack_context__.v({
  "face": "line-shadow-text-module__bQv2wW__face",
  "line-shadow": "line-shadow-text-module__bQv2wW__line-shadow",
  "root": "line-shadow-text-module__bQv2wW__root",
  "shadow": "line-shadow-text-module__bQv2wW__shadow",
});
